module.exports = __webpack_public_path__ + "img/mapmyrun.b3f440db.svg";